import numeral from 'numeral';

import { colors } from '../../../lib/colors';

/**
 * One colour per metric, taken from the shared chart palette by position so a card and the line
 * it selects in a trend read as the same thing on every GSC tool report.
 */
export const METRIC_COLORS = {
    clicks: colors[0],
    impressions: colors[1],
    position: colors[2],
    ctr: colors[3],
};

/**
 * Raw API values are formatted only here: CTR arrives as a fraction and position as a mean rank,
 * so each metric carries the numeral format that turns its own raw value into the displayed one.
 */
export const METRIC_FORMATS = {
    clicks: '0,0',
    impressions: '0,0',
    ctr: '0.00%',
    position: '0.0',
};

export function formatMetric(name, value) {
    if (value === null || value === undefined) return '—';
    return numeral(value).format(METRIC_FORMATS[name] ?? '0,0');
}

/**
 * A metric's change as a sentence fragment: an arrow, the size in the metric's own unit, and —
 * for counts — the percentage. The arrow describes the movement, while the colour a card gives it
 * describes whether that movement is good, which for average position are opposite things.
 */
export function deltaLabel(t, name, delta) {
    if (delta?.absolute === null || delta?.absolute === undefined) return null;

    const size = Math.abs(delta.absolute);
    const arrow = delta.absolute > 0 ? '↑' : delta.absolute < 0 ? '↓' : '↔';

    let text;
    if (name === 'ctr') text = `${numeral(size).format('0.00')} ${t('tools.gsc.units.pp')}`;
    else if (name === 'position')
        text = `${numeral(size).format('0.0')} ${t('tools.gsc.units.points')}`;
    else text = numeral(size).format('0,0');

    if (delta.percent !== null && delta.percent !== undefined) {
        text += ` (${numeral(delta.percent).format('+0.0')}%)`;
    }

    return `${arrow} ${text}`;
}
